import Repository from './repository';

const resource = '/dashboard';
export default {
	details() {
		return Repository.getWithAuth(`${resource}/details`);
	},
	searches() {
		return Repository.getWithAuth(`${resource}/searches`);
	},
	searchDetails() {
		return Repository.getWithAuth(`${resource}/searches_details`);
	},
	count() {
		return Repository.getWithAuth(`${resource}/comply/count`);
	},
	getDashboardSettings() {
		return Repository.getWithAuth(`${resource}/dashboard_settings`);
	},
	biRecords(payload) {
		return Repository.postWithAuth(`${resource}/merchant/bi_records`, payload);
	},
	getAllBiRecords(payload) {
		return Repository.postWithAuth(`${resource}/bi_records`, payload);
	},
};
